// Tier-2 <Stack> (FORT-182): the clearest token-binding primitive — gap is a
// spacing-scale step resolved from tokens, so there are no raw pixels at the call
// site. A plain flex div (no AntD), showing primitives needn't all wrap a library.
import React from 'react';
import { useTokens } from '../../core/theme/TokensProvider';
import type { Theme } from '../../core/theme/buildTokens';
import type { CommonProps } from './types';

/** A step on the 4px spacing scale (tokens.space): 0–7. */
export type SpaceStep = keyof Theme['space'];

export interface StackProps extends CommonProps {
  direction?: 'vertical' | 'horizontal';
  gap?: SpaceStep;
  align?: React.CSSProperties['alignItems'];
  justify?: React.CSSProperties['justifyContent'];
  wrap?: boolean;
  children: React.ReactNode;
}

export const Stack: React.FC<StackProps> = ({
  direction = 'vertical',
  gap = 3,
  align,
  justify,
  wrap,
  children,
  className,
  style,
  'data-testid': dataTestId,
}) => {
  const tokens = useTokens();
  return (
    <div
      className={className}
      data-testid={dataTestId}
      style={{
        display: 'flex',
        flexDirection: direction === 'vertical' ? 'column' : 'row',
        gap: tokens.space[gap],
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap ? 'wrap' : undefined,
        ...style,
      }}
    >
      {children}
    </div>
  );
};
